'use client';

import styles from 'styles/home/Home.module.scss'
import Button from 'componentsUnits/button';
import { useRouter } from 'next/navigation';
import Header from 'components/header';
import { Size } from 'types/size';
import Subtitle from 'componentsUnits/subtitle';
import ColumnComponent from 'componentsUnits/columnComponent';
import Break from 'componentsUnits/break';
import { Type } from 'types/type';
import { localeTexts } from 'locale/texts';

export default function Error() {
  const router = useRouter()

  return (
    <div className={`${styles.home_container}`}>
      <div className={styles.container}>
        <Header text={localeTexts.appTitle} disableBack />
        <div className={styles.content}>
          <Break />
          <ColumnComponent centerH>
            <Subtitle size={Size.large} type={Type.t1} text={localeTexts.sorry} />
            <p>{localeTexts.errorPageMessage}</p>
            <Button text={localeTexts.home} size={Size.small} type='1' onClick={() => router.push('/home')} />
            <Break />
            <Button text={localeTexts.back} size={Size.small} type='10' onClick={() => router.back()} />

          </ColumnComponent>
        </div>
      </div>
    </div>
  )
}
